import { makeApi } from "@zodios/core";
import { z } from "zod";

const UniqueContactSchema = z.object({
  orgUuid: z.string().uuid(),
  date: z.string().date(),
  count: z.number().int(),
});

const api = makeApi([
  {
    alias: "getUniqueContactsOverview",
    method: "get",
    path: "/api/v1/organizations/unique-contacts/overview",
    parameters: [
      { type: "Query", name: "dateFrom", schema: z.string().date() },
      { type: "Query", name: "dateTo", schema: z.string().date() },
    ],
    response: z.object({
      records: z.array(UniqueContactSchema),
      lastSuccessfulSyncAt: z.string().datetime({ offset: true }).nullable(),
      dataThroughDate: z.string().date().nullable(),
      dataAvailableFrom: z.string().date(),
    }),
  },
]);

export { api };
